import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resources from "./resources/resources";

i18n.use(initReactI18next).init({
  lng: "en",
  resources,
  keySeperator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
